import React from 'react';

const Section = ({ title, children }) => (
  <section className="static-section">
    <h2>{title}</h2>
    {children}
  </section>
);

export default function Privacy() {
  return (
    <div className="static-page">
      <div className="static-page__hero">
        <h1>Privacy Policy</h1>
        <p>Last updated: {new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}</p>
      </div>

      <div className="static-page__body">
        <Section title="1. Introduction">
          <p>MK Classes ("we", "our", "us") is committed to protecting your personal information. This Privacy Policy explains what data we collect, how we use it, and your rights regarding that data when you use our platform at mkclasses.com.</p>
        </Section>

        <Section title="2. Information We Collect">
          <ul className="static-list">
            <li><strong>Account information:</strong> Name, email address, and password when you register.</li>
            <li><strong>Profile information:</strong> Bio if you choose to provide it.</li>
            <li><strong>Learning activity:</strong> Queries you ask and sessions or meetings you join.</li>
            <li><strong>Usage data:</strong> Pages visited and actions taken on the platform (anonymised).</li>
          </ul>
        </Section>

        <Section title="3. How We Use Your Information">
          <ul className="static-list">
            <li>To create and manage your account</li>
            <li>To run personal sessions and group meetings</li>
            <li>To answer your queries</li>
            <li>To improve our platform and user experience</li>
            <li>To respond to your support queries</li>
          </ul>
        </Section>

        <Section title="4. Data Sharing">
          <p>We do not sell your personal data. We share data only as necessary:</p>
          <ul className="static-list">
            <li><strong>With MK Classes teachers:</strong> Your name, queries and joined sessions are visible to teachers.</li>
            <li><strong>Service providers:</strong> Hosting and infrastructure providers who are bound by confidentiality agreements.</li>
            <li><strong>Legal requirements:</strong> When required by law or to protect our rights.</li>
          </ul>
        </Section>

        <Section title="5. Data Security">
          <p>We use industry-standard security measures including password hashing (bcrypt), JWT-based authentication, and HTTPS encryption. However, no system is completely secure and we cannot guarantee absolute security.</p>
        </Section>

        <Section title="6. Your Rights">
          <ul className="static-list">
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate data</li>
            <li>Request deletion of your account and data</li>
            <li>Withdraw consent at any time</li>
          </ul>
          <p style={{ marginTop: '0.75rem' }}>To exercise any of these rights, contact us at <strong>metkarianis09@gmail.com</strong>.</p>
        </Section>

        <Section title="7. Cookies">
          <p>We use session storage and local storage to maintain your login session. We do not use third-party tracking cookies.</p>
        </Section>

        <Section title="8. Changes to This Policy">
          <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting a notice on the platform.</p>
        </Section>

        <Section title="9. Contact">
          <p>For any privacy-related questions, contact us at <strong>metkarianis09@gmail.com</strong>.</p>
        </Section>
      </div>
    </div>
  );
}
